import { css, keyframes, styled } from 'styled-components';

import { TFeedbackIconSizes } from '@components/web/src/atoms/ProductRating/ProductRating/RatingButton';
import { COLORS, RETAILER_COLORS } from '@components/web/src/styles';

const feedbackIconSizeMap: Record<TFeedbackIconSizes, number> = {
  large: 44,
  medium: 32,
  small: 24,
};

export const RatingButton = styled.button<{ $isLightVariant: boolean }>`
  position: relative;
  all: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;

  span {
    color: ${({ $isLightVariant }) => ($isLightVariant ? COLORS.base.white : RETAILER_COLORS.primary['600'])};
  }
`;

export const RatingImage = styled.img<{ $size: TFeedbackIconSizes }>`
  width: ${({ $size }) => feedbackIconSizeMap[$size]}px;
  height: ${({ $size }) => feedbackIconSizeMap[$size]}px;
  margin-top: ${({ theme }) => (theme?.isKioskRootElementType ? '-4px' : '-3px')};
`;

const bounceAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const FeedbackTooltipContainer = styled.div<{ $isAnimated: boolean; $isProductCardTooltip: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 161px;
  height: fit-content;
  text-align: center;
  padding: 8px 12px;
  border-radius: 8px;
  top: 135px;
  right: -5px;
  transition: all 0.3s ease;
  z-index: 999;
  background-color: ${COLORS.green['600']};
  animation: ${({ $isAnimated }) =>
    $isAnimated
      ? css`
          ${bounceAnimation} 2s infinite
        `
      : 'none'};

  span {
    color: ${COLORS.base.white};
  }
  ${({ $isProductCardTooltip }) =>
    $isProductCardTooltip &&
    css`
      top: 110px;
      right: 5px;
    `}
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid ${COLORS.green['600']};
  position: absolute;
  top: -10px;
  left: calc(85% - 12px);
`;
